import React, { useEffect, useState } from 'react';
import { NoParamsFn } from 'tae/timesheets/types';
import { Dialog, ErrorButton } from '@beeline.com/bp-design-system';
import StyledDialogContent from 'src/components/finance/timeAndExpenses/timesheets/layout/dialog/DialogContent';
import { JobFamilyGroup } from './jobFamilyGroups.graphql';
import { useJobFamilyGroupsIntl } from './translations/useJobFamilyGroupsIntl';

interface JobFamilyGroupDeleteDialogProps {
  show: boolean;
  isLoading: boolean;
  onClose: NoParamsFn;
  onSubmit: NoParamsFn;
  jobFamilyGroups: JobFamilyGroup[];
  workdayJobFamilyGroups: JobFamilyGroup[];
  uids: string[];
  isBulkAction: boolean;
}

export const JobFamilyGroupDeleteDialog: React.FC<React.PropsWithChildren<JobFamilyGroupDeleteDialogProps>> = ({
  show,
  isLoading,
  onClose,
  onSubmit,
  jobFamilyGroups,
  workdayJobFamilyGroups,
  uids,
  isBulkAction
}) => {
  const intl = useJobFamilyGroupsIntl();
  const [formName, setFormName] = useState('');

  useEffect(() => {
    setFormName(jobFamilyGroups.map((jobFamilyGroup) => `"${jobFamilyGroup?.name ?? ''}"`).join(', '));
  }, [jobFamilyGroups]);

  const resultMessage = isBulkAction
    ? intl.confirmDeleteJobFamilyGroups({
        formName,
        totalCount: uids.length
      })
    : intl.confirmDeleteJobFamilyGroup;

  return (
    <Dialog
      open={show}
      onClose={onClose}
      dataTest="confirm-delete-job-family-groups-dialog"
      title={intl.deleteJobFamilyGroup}
      show={{ cancelButton: true }}
      disableBackdropClick
      actions={[
        <ErrorButton.Contained
          key="confirm-button"
          dataTest="job-family-group__confirm-delete-button"
          disabled={uids.length < 1}
          onClick={onSubmit}
          loading={isLoading}
        >
          {intl.confirmAndDelete}
        </ErrorButton.Contained>
      ]}
    >
      <StyledDialogContent style={{ padding: 0 }}>
        {resultMessage}
        {workdayJobFamilyGroups.length > 0 && isBulkAction && (
          <StyledDialogContent style={{ padding: 0 }}>
            {intl.jobFamilyGroupsCannotBeDeleted}
            <ul>
              {workdayJobFamilyGroups.map((jobFamilyGroup) => (
                <li key={jobFamilyGroup.uid}>{jobFamilyGroup.name}</li>
              ))}
            </ul>
          </StyledDialogContent>
        )}
      </StyledDialogContent>
    </Dialog>
  );
};
